import { Size } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import './ColorArray.scss';

export interface IColorArrayProps {
  colors: string[];
  colorSize: Size;
  selectedColors?: string[] | null;
  error?: boolean;
  onClick?: (color: string) => void;
  className?: string | object;
}

const ColorArray = (props: IColorArrayProps) => {
  const { colors, colorSize, selectedColors, error, onClick, className } = props;

  function renderColors() {
    return colors.map((color) => {
      const onColorSelect = () => {
        if (onClick) {
          onClick(color);
        }
      };

      const active = selectedColors?.some((selected) => color === selected);

      const colorClass = classNames({
        'circle-wrapper': true,
        [`circle-size-${colorSize}`]: true,
        active,
      });

      return (
        <div className={colorClass} key={color} style={{ border: active ? `1px solid ${color}` : undefined }}>
          <div className="circle" onClick={onColorSelect} style={{ backgroundColor: color }} />
        </div>
      );
    });
  }

  const classes = classNames(
    {
      [`size-${colorSize}`]: true,
      'color-array': true,
      'error': error,
    },
    className
  );

  return <div className={classes}>{renderColors()}</div>;
};

export const ColorPickerDefaultValues = [
  '#f44336',
  '#e91e63',
  '#f451ba',
  '#9e1f63',
  '#9c27b0',
  '#673ab7',
  '#3f51b5',
  '#264968',
  '#2096f3',
  '#02a9f4',
  '#00bcd4',
  '#009688',
  '#39b5a4',
  '#8bc34a',
  '#cddc39',
  '#efca14',
  '#ffc105',
  '#ff9800',
  '#795548',
  '#a97c50',
  '#669aaf',
  '#607d8b',
  '#939598',
  '#58595b',
  '#111111',
];

ColorArray.defaultProps = {
  colorSize: Size.MEDIUM,
  // default colors for calendar and daily project report
  colors: ColorPickerDefaultValues,
};

export default ColorArray;
